var _a;
import * as actions from './state/actions';
export var eventsMap = (_a = {},
    // View/Search for Products
    _a[actions.ActionTypes.BIN_SEARCH_SUCCESS] = function (action) {
        return {
            hitType: 'transaction',
            data: action.payload
        };
    },
    // Add product to shopping card
    _a[actions.ActionTypes.SELECT_CARD_TYPE] = function (action) {
        return {
            hitType: 'transaction',
            data: action.payload
        };
    },
    _a);
